module.exports = __webpack_public_path__ + "static/media/playstore_logo.e17e26a2.svg";